import { StyleSheet } from 'aphrodite/no-important';
import { GenericObject } from 'models';
import { RegionID, SurveyFieldType } from 'models/survey';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (options: GenericObject) => {
  const WIDTH_PERCENTAGE = {
    FIELD_DESCRIPTION: '48%',
    FIELD_INPUTS: '52%',
  };
  const { hasCustomOptions = false, surveyFieldType = SurveyFieldType.RADIO, region = RegionID.NA } = options;

  return StyleSheet.create({
    agreementForm: {
      width: '100%',
      [media.tablet]: {
        width: '100vw',
        margin: `0px calc((-100vw + 100%)/2)`,
      },
      [media.desktop]: {
        width: '100%',
        margin: '0px',
      },
    },
    description: {
      width: '100%',
      textAlign: 'center',
      [children('p')]: {
        margin: '25px 0px',
        fontSize: 16,
        fontWeight: 'bold',
      },
      [children('span')]: {
        display: 'block',
      },
      [children(':not(:last-child)')]: {
        marginBottom: 25,
      },

      [media.tablet]: {
        [children('p')]: {
          fontSize: 20,
          padding: ' 0px 20px',
          textAlign: 'left',
        },
      },
      [media.desktop]: {
        [children('p')]: {
          padding: ' 20px 65px',
          textAlign: 'left',
        },
      },
    },
    subsection: {
      [media.smallerThanTablet]: {
        marginBottom: '16px',
      },
    },
    subsectionTitle: {
      width: '100%',
      textAlign: 'center',
      backgroundColor: palette.red,
      padding: '15px 20px',
      fontSize: '20px',
      lineHeight: '24px',
      fontWeight: 'bold',
      [media.smallerThanTablet]: {
        width: '100vw',
        margin: `0px calc((100% - 100vw)/2)`,
      },
    },
    row: {
      width: '100%',
      padding: '30px',
      display: 'inline-flex',
      alignItems: 'center',
      [media.smallerThanTablet]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 0,
      },
    },
    headline: {
      width: '100%',
      padding: '30px',
      display: 'inline-flex',
      alignItems: 'center',
      borderTop: '1px solid red',
      borderBottom: '1px solid red',
      [media.smallerThanTablet]: {
        padding: '0 26px',
        width: '100vw',
        margin: `0px calc((100% - 100vw)/2)`,
      },
    },
    tableTitle: {
      fontSize: 24,
      fontWeight: 'bold',
      [media.smallerThanTablet]: {
        textAlign: 'center',
      },
    },
    descriptionColumn: {
      width: WIDTH_PERCENTAGE.FIELD_DESCRIPTION,
      [media.smallerThanTablet]: {
        width: '100%',
        padding: '20px 0',
      },
    },
    fieldDescriptionTitle: {
      fontSize: 16,

      [media.tablet]: {
        width: '75%',
      },

      ':first-letter': {
        fontWeight: 'bold',
      },
    },
    fieldDescriptionTitleRequired: {
      position: 'relative',

      '::before': {
        content: '"*"',
        position: 'absolute',
        left: '-1ch',
        color: palette.red,
      },
    },
    rows: {
      [media.tablet]: {
        ':nth-child(1n) > div:nth-child(2n+1)': {
          backgroundColor: palette.black,
        },
        ':nth-child(1n) > div:nth-child(2n)': {
          backgroundColor: palette.lightDarkGrey,
        },
      },
    },
    optionContainer: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      width: WIDTH_PERCENTAGE.FIELD_INPUTS,

      [media.smallerThanTablet]: {
        width: '100vw',
        padding: '5px 32px',
        backgroundColor: surveyFieldType === SurveyFieldType.TEXT ? 'transparent' : palette.lightDarkGrey,
        borderBottom: `1px solid ${palette.red}`,
        justifyContent: 'flex-start',
      },
    },
    option: {
      width: `${100 / 5}%`,
      display: 'flex',
      flexDirection: region === RegionID.JP ? 'column-reverse' : 'column',
      justifyContent: 'flex-end',
      alignItems: 'center',
      textAlign: 'center',
      [media.smallerThanTablet]: {
        width: `${100 / 2}%`,
        margin: '5px 0',
        flexDirection: 'row-reverse',
        justifyContent: 'flex-end',
      },
      [children('> span')]: {
        display: hasCustomOptions ? 'flex' : 'none',
        justifyContent: 'center',
        flexWrap: 'wrap',
        width: 'fit-content',
        marginBottom: region === RegionID.JP ? 0 : 10,
        marginTop: region === RegionID.JP ? 10 : 0,
        ':nth-child(even)': {
          marginRight: 10,
        },
        [media.smallerThanTablet]: {
          display: 'block',
          textAlign: 'left',
          marginLeft: '14px',
          marginBottom: 0,
        },
      },
    },
    textInput: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      marginBottom: '30px',
      background: 'transparent',

      [children('input')]: {
        width: '100%',
        height: '100%',
        color: palette.white,
        borderRadius: '5px',
        border: `1px solid ${palette.white}`,
        background: 'transparent',
        padding: '7px 15px',
      },

      [media.tablet]: {
        width: '90%',
        marginBottom: '0px',
      },
    },

    headerOptionColumn: {
      width: `calc(${WIDTH_PERCENTAGE.FIELD_INPUTS} / 5)`,
      display: 'flex',
      flexDirection: 'column',
      justifyConent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      [media.smallerThanTablet]: {
        display: 'none',
      },
    },

    required: {
      color: palette.red,
      fontWeight: 'bold',
    },
  });
};

export const rowStyles: any = (options: GenericObject) => {};
